"use client"

import { useTheme } from "next-themes"

import { cn } from "@/lib/utils"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

enum Theme {
  Light = "light",
  Dark = "dark",
}

interface ToggleThemeProps {
  className?: string
}

export function ToggleTheme({ className }: ToggleThemeProps) {
  const { theme, setTheme } = useTheme()

  return (
    <Select defaultValue={theme} onValueChange={setTheme}>
      <SelectTrigger className={cn("capitalize", className)}>
        <SelectValue placeholder="Select Theme" />
      </SelectTrigger>
      <SelectContent>
        {Object.values(Theme).map((cur) => (
          <SelectItem key={cur} value={cur} className="capitalize">
            {cur}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
